import { palette } from '@centivo/react-components'
import styled from 'styled-components'

import { Content, ContentSection } from 'src/refactor/structure'

const mobileThreshold = '800px'
const minWidthThreshold = '1200px'

export const TestimonialsContent = styled(Content)`
  background-color: ${palette.brand.purple};
  margin: 0 0 6.25rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`

export const TestimonialsContentSection = styled(ContentSection)`
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
  grid-column-gap: 0.625rem;
  color: ${palette.neutral.white};
  padding: 2rem 0 4.75rem 0;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (max-width: ${mobileThreshold}) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    grid-template-columns: 100%;
  }

  @media (min-width: ${minWidthThreshold}) {
    grid-template-columns: 100%;
  }
`

const BaseTitleLikeText = styled.span`
  grid-column: 1 / span 3;
  font-size: 1.25rem;
  text-align: center;
  font-weight: 600;

  @media (max-width: ${mobileThreshold}) {
    grid-column: 1;
    font-size: 1.125rem;
  }

  @media (min-width: ${minWidthThreshold}) {
    grid-columns: 1;
  }
`

export const TestimonialsSubtitle = styled(BaseTitleLikeText)`
  grid-row: 2;
  padding: 0 0 2rem 0;
`

export const TestimonialsTitle = styled(BaseTitleLikeText)`
  grid-row: 1;
  font-size: 2.5rem;
  font-weight: bold;

  @media (max-width: ${mobileThreshold}) {
    font-size: 1.8rem;
  }
`

export const InstancesContainer = styled.div`
  grid-column: 2;
  grid-row: 3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${mobileThreshold}) {
    grid-column: 1;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: ${minWidthThreshold}) {
    grid-column: 1;
  }
`

export const TestimonialInstanceContainer = styled.div<{ borderColor: string }>`
  background-color: ${palette.neutral.white};
  border: solid 5px ${props => props.borderColor};
  padding: 2rem 1.5rem;
  width: calc((100% - 24px * 2) / 3);
  text-align: center;

  span {
    color: ${palette.brand.purple};
    font-size: 2vw;
    font-weight: bold;
  }

  @media (max-width: ${mobileThreshold}) {
    margin-bottom: 1.5rem;
    min-height: 15.75rem;
    width: 100%;
    max-width: 21rem;

    span {
      font-size: 1.5rem;
    }
  }

  @media (min-width: 1300px) {
    span {
      font-size: 1.625rem;
    }
  }
`
